import * as React from 'react';

import wrapStore from '@src/utils/wrap-store';
import FooterStore from './store';
import styles from './index.less';

const Footer = ({ store }) => {
  store.use();
  return (
    <div className={styles.root}>
      <div className="footer oversea footer_service" data-flm-layer-name="footer">
        <div className="footer_container">
          <div className="footer_top">
            <div className="footer_information_container">
              <ul className="information_list">
                <div className="information_title">官方工具</div>
                <li>
                  <a className="link" href="https://g.xoyo.com/#/" target="_blank">
                    <p>启动器</p>
                  </a>
                </li>
                <li>
                  <a className="link" href="https://www.seasunwbl.com/" target="_blank">
                    <p>万宝楼</p>
                  </a>
                </li>
                <li>
                  <a className="link" href="https://www.xoyo.com/apps" target="_blank">
                    <p>游戏管家</p>
                  </a>
                </li>
              </ul>
              <ul className="information_list">
                <div className="information_title">用户服务</div>
                <li>
                  <a className="link" href="https://passport.xoyo.com/signin?redirect=https%3A%2F%2Fcharge.xoyo.com%2Fcharge-items" target="_blank">
                    充值中心
                  </a>
                </li>
                <li>
                  <a className="link" href="https://passport.xoyo.com/signin?redirect=https%3A%2F%2Fi.xoyo.com%2F" target="_blank">
                    个人中心
                  </a>
                </li>
                <li>
                  <a className="link" href="https://help.xoyo.com/help?category=4115" target="_blank">
                    帮助中心
                  </a>
                </li>
                <li>
                  <a className="link" href="https://support.seasungames.cn/" target="_blank">
                    客服中心
                  </a>
                </li>
              </ul>
              <ul className="information_list">
                <div className="information_title">了解我们</div>
                <li>
                  <a className="link" href="https://about.seasungames.cn" target="_blank">
                    企业文化
                  </a>
                </li>
                <li>
                  <a className="link" href="https://www.xoyo.com/news-list" target="_blank">
                    新闻资讯
                  </a>
                </li>
              </ul>
              <ul className="information_list">
                <div className="information_title">加入我们</div>
                <li>
                  <a className="link" href="https://job.seasungames.cn" target="_blank">
                    社会招聘
                  </a>
                </li>
                <li>
                  <a className="link" href="https://job.seasungames.cn/campus" target="_blank">
                    校园招聘
                  </a>
                </li>
                <li>
                  <a className="link" href="https://sc.xishanju.com/?utm_source=HrSite2022pc#/" target="_blank">
                    训练营
                  </a>
                </li>
              </ul>
              <ul className="information_list">
                <div className="information_title">关注我们</div>
                <li>
                  <a className="link" href="https://weibo.com/u/2074833864" target="_blank">
                    官方微博
                  </a>
                </li>
                <li className="linkHover">
                  <a className="link">官方公众号</a>
                  <div className="qrcode_container" style={{ backgroundImage: 'url(https://static-job.seasungames.cn/1724925299236_qrcode.jpeg)' }} />
                </li>
              </ul>
              <ul className="information_list">
                <div className="information_title">联系我们</div>
                <li>
                  <a className="link" href="https://www.xishanju.com/cn/contact.html" target="_blank">
                    联系方式
                  </a>
                </li>
                <li>
                  <a className="link" href="https://scm.seasungames.cn/index/index.html" target="_blank">
                    采购合作
                  </a>
                </li>
              </ul>
            </div>
            <div className="r_top">
              <div className="topBtn">
                <div className="toTopBtn toTopBtnAct" />
              </div>
            </div>
          </div>
          <div className="footer_bottom">
            <div className="l_bottom">
              <p>
                <a className="link" href="https://www.seasungames.cn/index.html#/privacy-notice" target="_blank">
                  隐私协议
                </a>{' '}
                |{' '}
                <a className="link" href="https://www.seasungames.cn/p/zt/2024/06/20/index/#/terms-of-service" target="_blank">
                  服务协议
                </a>{' '}
                |{' '}
                <a className="link" href="https://www.seasungames.cn/p/zt/2024/06/20/index/#/industry-convention" target="_blank">
                  网络游戏行业防沉迷自律公约
                </a>{' '}
                |{' '}
                <a className="link" href="https://www.12377.cn/" target="_blank">
                  违法和不良信息举报中心
                </a>
              </p>
              <p>
                <a className="link" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                  蜀ICP备14009198号-52{' '}
                </a>
                <a className="link" href="https://beian.mps.gov.cn/#/query/webSearch?code=51019002006903" rel="noreferrer" target="_blank">
                  川公网安备51019002006903号
                </a>
              </p>
              <p>
                <span>Copyright © 1999-2025 成都西山居世游科技有限公司 版权所有</span>
              </p>
              <p>
                <span>健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</span>
              </p>
            </div>
            <div className="r_bottom">
              <a
                className="link footer_kingsoft_logo"
                href="https://www.kingsoft.com/"
                target="_blank"
                style={{ backgroundImage: 'url(https://static-job.seasungames.cn/1724923824279_ks_logo.png)' }}
              />
              <a
                className="link footer_seasun_logo"
                href="https://www.seasungames.cn/#/"
                target="_blank"
                style={{ backgroundImage: 'url(https://static-job.seasungames.cn/1724931374354_s_white_logo.png)' }}
              />
            </div>
          </div>
          {/* <div className="qrcode_container" style={{ backgroundImage: 'url(https://static-job.seasungames.cn/1724925299236_qrcode.jpeg)' }} /> */}
          <div className="footer_back_top" onClick={store.backHome} />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(Footer, FooterStore);
